import React from 'react';

/**
 * BodyContainer wraps block content (bullets, text description) and restricts
 * reading width to 72ch to prevent excessive horizontal stretching.
 */
export const BodyContainer = ({ children, style = {} }) => {
  return (
    <div 
      className="block-body-container"
      style={{
        maxWidth: 'var(--reading-width, 72ch)',
        width: '100%',
        ...style
      }}
    >
      {children}
    </div>
  );
};
export default BodyContainer;
